import api from '../../plugins/api';

const addDealComment = (payload) => {
  return api.post('/api/crm/deals/addDealComment', payload);
};

export default addDealComment;
